/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionRadioOn: {
  name: 'temp-selection-radio-on';
  data: string;
} = {
  name: 'temp-selection-radio-on',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z" fill="currentColor"/></svg>`,
};
